var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWorkOrders = function SvgWorkOrders(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75.003A2.25 2.25 0 0115 2.253V3h2.75A2.25 2.25 0 0120 5.25v8.497a2.25 2.25 0 01-2.25 2.25H2.25A2.25 2.25 0 010 13.747V5.25A2.25 2.25 0 012.25 3H5v-.747A2.25 2.25 0 017.25.003h5.5zM4.5 9h-3v4.747c0 .414.336.75.75.75h15.5a.75.75 0 00.75-.75V9h-3v1.25a.75.75 0 01-1.5 0V9H6v1.25a.75.75 0 01-1.5 0V9zm13.25-4.5H15l-1.5.003-7-.003-1.5.003L2.25 4.5a.75.75 0 00-.75.75V7.5h3v-.75a.75.75 0 011.5 0v.75h8v-.75a.75.75 0 011.5 0v.75h3V5.25a.75.75 0 00-.75-.75zm-5-2.997h-5.5a.75.75 0 00-.75.75V3h7v-.747a.75.75 0 00-.75-.75z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWorkOrders, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/workOrders.c5ec141b.svg";
export { ForwardRef as ReactComponent };